import { DateTime } from "luxon";
import { Cell } from "../Cell";
import { ApplicantOrInvitee } from "../../types";
import { EmptyCellIcon } from "./components/EmptyCellIcon";

interface ApplicationStartedCellProps {
  applicant: ApplicantOrInvitee;
}

export const ApplicationStartedCell = ({
  applicant
}: ApplicationStartedCellProps) => {
  const isApplicant = "verifications" in applicant;

  return (
    <Cell isFirst isDataCell className="text-content-400">
      {isApplicant && applicant.application_started_at ? (
        DateTime.fromISO(applicant.application_started_at).toFormat(
          "MMM dd, yyyy 'at' h:mm a"
        )
      ) : (
        <EmptyCellIcon />
      )}
    </Cell>
  );
};
